import { CSSObject } from '@emotion/react'
import { inkFontTokens, inkTokens } from '@ds/tokens'
import { CreateFocusCss } from '@ds/ui'

export const phoneInputContainer: CSSObject = {
  display: 'flex',
}

export const getTriggerStyles = (
  isInk: boolean,
  isRTL: boolean
): {
  triggerBtn: CSSObject
  triggerBtnChildren: CSSObject
} => {
  return {
    triggerBtn: {
      alignItems: 'center',
      label: 'triggerBtn',
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
      direction: isRTL ? 'ltr' : undefined,
      display: 'flex',
      minHeight: `calc(${inkTokens.global.ctaSizeMd} - 2px)`,
      '@media (hover: none) and (pointer: coarse)': {
        minHeight: `calc(${inkTokens.global.ctaSizeLg} - 2px)`,
      },
      paddingInline: isInk ? '16px 4px' : '8px 4px',
      fontFamily: 'inherit',
      ...CreateFocusCss(inkTokens.light.focusOuter),
    },
    triggerBtnChildren: {
      alignItems: 'center',
      label: 'triggerBtnChildren',
      display: 'flex',
      fontSize: isInk ? 16 : 13,
      color: inkFontTokens.fontColorDefault,
      letterSpacing: isInk ? 'normal' : 0.66,
      '&:hover': {
        color: inkFontTokens.fontColorLinkHover,
        '& svg': {
          fill: inkFontTokens.fontColorLinkHover,
        },
      },
    },
  }
}

export const phoneInputWithoutExtension: (
  isRTL: boolean,
  useCallingCodeMenu: boolean,
  startElement?: boolean,
  leftElement?: boolean
) => CSSObject = (isRTL, useCallingCodeMenu, startElement, leftElement) => {
  return {
    flexGrow: 1,

    '.input-text-box-wrapper': {
      input: {
        overflow: 'hidden',
        ...(useCallingCodeMenu &&
          isRTL && {
            paddingInlineStart: 0,
          }),
        ...(!useCallingCodeMenu &&
          isRTL &&
          (startElement || leftElement) && {
            paddingInlineStart: 16,
          }),
      },
    },
  }
}

export const extensionErrorContainer: CSSObject = {
  marginTop: '8px',
}

export const getExtensionContainerStyles = ({
  hideLabel,
  hideLabelExt,
  isInk,
}: {
  hideLabel: boolean
  hideLabelExt: boolean
  isInk: boolean
}) => {
  const style: CSSObject = {
    width: isInk ? 95 : 65,
    marginInlineStart: 10,
    flexShrink: 0,
  }
  if (hideLabelExt && !hideLabel) {
    style.position = 'relative'
    style.top = isInk ? 32 : 22
  }
  return style
}

export const noMatchesContainer: CSSObject = {
  textAlign: 'center',
}

export const searchInputContainer: CSSObject = {
  borderBottom: '1px solid #ddd',
  paddingBlock: '2px 10px',
  paddingInline: inkTokens.global.spacingGap300,
}

export const preferredListContainer: CSSObject = {
  borderBottom: '1px solid #ddd',
  paddingTop: 10,
  paddingBottom: 10,
}

export const countryListContainer: CSSObject = {
  paddingTop: 10,
  paddingBottom: 10,
}
